import { SALE_CONFIG } from '@/saleConfig'

export const MOBILE_NAVIGATION_CONFIG = {
  magicCategories: [
    {
      title: 'Performance Style',
      items: [
        { name: 'Card magic tricks', href: '/card-magic' },
        { name: 'Close-up magic', href: '/close-up-magic' },
        { name: 'Mentalism', href: '/mentalism' },
        { name: 'Parlor & stage magic', href: '/stage-and-parlor-magic' },
        { name: 'Money magic', href: '/money-magic' },
        { name: 'Kids entertainment', href: '/amazekids' },
        { name: 'Virtual magic shows', href: '/virtual-magic-shows' },
      ],
    },
    {
      title: 'Product Type',
      items: [
        { name: 'Magic books', href: '/magic-books' },
        { name: 'Magic DVDs', href: '/magic-dvds' },
        { name: 'Magic magazines', href: '/magic-magazines' },
        { name: 'Easy tricks', href: '/easy-magic-tricks' },
        { name: 'Magic theory', href: '/magic-theory' },
        { name: 'Magic history', href: '/magic-history' },
        { name: 'Puzzles & Wonders', href: '/wonders/' },
      ],
    },
    {
      title: 'Props & Accessories',
      items: [
        { name: 'Playing cards', href: '/playing-cards' },
        { name: 'Coin gimmicks', href: '/coin-gimmicks' },
        { name: 'Magic apps', href: '/magic-apps' },
        { name: "Rubik's Cube", href: '/rubiks-cube-magic' },
        { name: 'Brand store', href: '/brand-store' },
        { name: 'All props', href: '/props/' },
      ],
    },
  ],

  /** Download categories for Magic Downloads section (match MagicDownloadsMenu and category slugs) */
  downloadCategories: [
    { name: 'Card magic', href: '/card-magic-downloads/' },
    { name: 'Coin magic', href: '/coin-magic-downloads/' },
    { name: 'Magic ebooks', href: '/ebooks/' },
    { name: 'All downloads', href: '/magic-downloads/' },
  ],

  /** Exclusive categories for Exclusives section */
  exclusiveCategories: [
    { name: 'Exclusive books', href: '/exclusives/magic-books' },
    { name: 'Exclusive downloads', href: '/exclusives/downloads/' },
    { name: 'Exclusive tricks', href: '/exclusives/tricks' },
    { name: 'All exclusives', href: '/exclusives' },
  ],

  /** Featured links displayed prominently at the top */
  featuredLinks: [
    { name: 'New Magic', href: '/magic-tricks' },
    { name: 'VI Masterclass lectures', href: '/masterclass' },
    { name: 'Easy Magic Tricks', href: '/easy-magic-tricks' },
  ],

  /** Other important links */
  otherLinks: [
    ...(SALE_CONFIG.saleActive
      ? [{ name: 'Sale', href: '/sale/all/', highlighted: true }]
      : []),
    { name: 'VI Magic Stores', href: '/magic-stores' },
    { name: 'Magic Conventions', href: '/magic-conventions' },
    { name: 'Podcast', href: '/insider-magic-podcast' },
    { name: 'Blog', href: '/blog/' },
    { name: 'Gift Cards', href: '/gift-certificates/' },
  ],
}
